export default {
    reset_company_auth_title: "Reset Cognito Authentication",
    reset_company_auth_success_message: "Cognito authentication was reset",
    reset_company_auth_error_message: "Cognito authentication could not be reset due to an error",
    reset_company_auth_message: "Do you want to reset cognito authentication?",
    reset_company_auth_label: "Reset",
};